module.exports = __webpack_public_path__ + "static/media/1612930953408.70bbfcaf.jpg";